<div class="crud-editor-div">
    <mat-card>
        <mat-card-title>Acknowledge Assignment</mat-card-title>
        <mat-card-content>
            
            <div *ngIf="isAcknowledgeAssignmentEnabled()">
                <div class="crud-item-section">
                    <button mat-raised-button color="primary" (click)="acknowledgeAssignmentHandover()">Acknowledge Handover</button>
                </div>
            </div>

            <div *ngIf="acknowledged">
                <div class="crud-item-section">
                    <span class="crud-editor-info">Firearm assignment handover successfully acknowleged.</span>
                </div>
            </div>
            <div *ngIf="error">
                <div class="crud-item-section">
                    <h1 class="crud-editor-warning">Firearm assignment handover acknowledgement failed.</h1>
                </div>
                <div>
                    <h2>{{error.title}}</h2>
                </div>
                <div>
                    <span>{{error.message}}</span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>